import {
  Button,
  Classes,
  Dialog,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import {
  IFilter,
  INfseItem,
  IResultadoItem,
} from "../../../../model";
import { ResultadoStore } from "../../../../stores/resultados/ResultadoStore";
import * as moment from "moment";
import { AppStore } from "../../../../stores/AppStore";
import { copyToClipboard, formatCnpj } from "../../../../utils";
import { toast } from "react-toastify";
import { api } from "../../../../api";
import { ItemMemoria } from "./ItemMemoria";
import { MDBBtn } from "mdbreact";
const numeral = require("numeral");

interface NfseItemDialogProps {
  item: IResultadoItem;
  modelo: string;
  entrada_saida: string;
  data: any;
  onClose: () => void;
}

interface NfseItemDialogState { }

@observer
export class NfseItemDialog extends React.Component<
  NfseItemDialogProps,
  NfseItemDialogState
> {

  obs = observable({
    item: {} as INfseItem,
    filtro: {} as IFilter,
    dhemi: null as string
  })

  async componentDidMount() {
    let data = {
      tipo: this.props.entrada_saida.toLowerCase(),
      id: this.props.item._id,
      modelo: this.props.modelo,
    };

    this.obs.filtro = {
      tipo: this.props.modelo,
      filtro: this.props.entrada_saida,
      empresa: AppStore.obs1.selectedEmpresa,
      data1: moment(this.props.data[0]).format("YYYY-MM-DD"),
      data2: moment(this.props.data[1]).format("YYYY-MM-DD"),
      ids: [""],
    };

    try {
      let resp = await api.post(`/api/notas/nfse/item`, data);
      this.obs.item = resp.data;
      this.obs.dhemi = resp.data.dhemi;

      if (resp.data.calc_id) await ResultadoStore.loadDetalhamentoCalculo(resp.data.calc_id);

    } catch (ex) { }
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleViewXML = async (chave: string, entrada_saida: string, modelo: string, dhemi: string) => {
    await ResultadoStore.download_xml(chave, entrada_saida, modelo, dhemi, AppStore.obs1.selectedEmpresa?.cnpj);
  };

  handleCopyChave = () => {
    copyToClipboard(this.obs.item?.chave);
    toast.success("Chave de acesso copiada", {});
  };

  handleCopyId = () => {
    copyToClipboard(this.obs.item?.contestacao_id);
    toast.success("Id Contestação copiado", {});
  };

  handleViewPDF = async () => {
    var ids = {
      ids: [{ cancelada: false, chave: this.obs.item.chave }],
      filtro: this.props.entrada_saida,
      tipo: this.props.modelo,
      empresa: AppStore.obs1.selectedEmpresa.cnpj,
      data1: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
      data2: moment(this.obs.item.dhemi).format("YYYY-MM-DD"),
    };

    await ResultadoStore.view_danfe(ids, this.obs.item.chave, AppStore.obs1.selectedEmpresa);
  };

  renderDetailsTab() {
    return (
      <div>

        {this.obs.item.chave && (
          <div className="item-dialog-chave">
            <span className="detalhamento-field-label">Chave</span>
            <div className="item-dialog-chave-value">
              <span>{this.obs.item.chave}</span>
              <Button small minimal icon="clipboard" onClick={this.handleCopyChave} />
            </div>
          </div>
        )}

        <div className="item-dialog-descricao">
          <span className="detalhamento-field-label">Descrição</span>
          <span style={{lineHeight: 1.5, textAlign: "justify"}}>{this.obs.item.descricao}</span>
        </div>

        <div className="item-dialog-grid">
          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Tributação</span>
            <span className="detalhamento-field-value">{this.obs.item.forma_tributacao}</span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">ISSQN</span>
            <span className="detalhamento-field-value">
              {numeral(this.obs.item.issqn).format("$ 0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Valor do Item</span>
            <span className="detalhamento-field-value">
              {numeral(this.obs.item.valor).format("$ 0,0.00")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Prestador</span>
            <span className="detalhamento-field-value">
              {this.obs.item.prestador ? formatCnpj(this.obs.item.prestador) : "-"}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Tomador</span>
            <span className="detalhamento-field-value">
              {this.obs.item.tomador ? formatCnpj(this.obs.item.tomador) : "-"}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da inserção</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item.inserted_at).format("L LT")}
            </span>
          </div>

          <div className="detalhamento-field">
            <span className="detalhamento-field-label">Data da atualização</span>
            <span className="detalhamento-field-value">
              {moment(this.obs.item._modifiedTS).format("L LT")}
            </span>
          </div>

        </div>

        {this.obs.item?.contestacao_id && (
          <div className="item-dialog-chave">
            <span className="detalhamento-field-label">ID Contestação</span>
            <div className="item-dialog-chave-value">
              <span>{this.obs.item?.contestacao_id}</span>
              <Button small minimal icon="clipboard" onClick={this.handleCopyId} />
            </div>
          </div>
        )}

        <div className="item-dialog-actions">
          <MDBBtn
            className="btnDefault btnExportResultados"
            onClick={() => this.handleViewXML(this.obs.item.chave, this.props.entrada_saida, this.props.modelo, this.obs.dhemi)}>
            Download XML
          </MDBBtn>
          <MDBBtn
            className="btnDefault btnExportResultados"
            onClick={() => this.handleViewPDF()}>
            Download PDF
          </MDBBtn>
        </div>
      </div>
    );
  }

  renderMemoriaCalc(memoria_calculo: string) {
    let calcName: any = this.obs.item.calc ? this.obs.item.calc : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars}
        nota_vars={ResultadoStore.obs.nota_vars}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderData() {
    return (
      <Tabs id="tabs" className="tabsCalculos tabsDetail">
        <Tab id="details" title="Detalhes" panel={this.renderDetailsTab()} />
        {this.obs.item.memoria_calculo ?
          <Tab
            id="calc"
            title="Memória de cálculo ICMS"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_1139 ?
          <Tab
            id="calc_1139"
            title="Memória de cálculo ICMS 1139"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo_1139)}
          />
          : <></>}
      </Tabs>
    );
  }

  render() {
    let title = "Detalhes";
    if (this.obs.item) {
      title = `Detalhes: ${this.obs.item.nnfe}`;
    }

    return (
      <Dialog
        isOpen={true}
        title={title}
        onClose={this.props.onClose}
        className="detail-item"
      >
        <div className={Classes.DIALOG_BODY}>
          {(this.obs.item && this.renderData()) || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={this.props.onClose} />
          </div>
        </div>
      </Dialog>
    );
  }
}
